import { render } from "./data-policy.vue?vue&type=template&id=5366fc96&scoped=true&ts=true"
import script from "./data-policy.ts?vue&type=script&lang=ts&external"
export * from "./data-policy.ts?vue&type=script&lang=ts&external"

import "./data-policy.less?vue&type=style&index=0&id=5366fc96&lang=less&scoped=true&external"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5366fc96"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator,QOptionGroup});
